// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2H0qz","choiceBoxes":"toolbarselects_choiceBoxes__3svQh","simpleField":"toolbarselects_simpleField__ZSQ_y"};